import React from "react";
import { Col, Layout, Row, Typography } from 'antd';
import styled from "styled-components";
import EmoshareIcon from "components/icons/EmoshareIcon";

const { Header } = Layout;
const { Text } = Typography;

const StyledHeader = styled(Header)`
  background: #fff;
  width: 100%;
`;

const StyledLogoHeader = styled.a`
  width: 250px;
  height: 30px;
  margin: 16px 5px 0 5px;
  color: #EB920C !important;
  font-weight: bold;
  font-size: 1.5em;
  text-decoration: none;
`;

const _appHeader: React.FC = (props) => {
  return (
    <StyledHeader>
      <Row align="middle" justify="center">
        <Col>
          <Text>
            <StyledLogoHeader href="/">
              <EmoshareIcon width={120}/>
              {/* @@ EMOSHARE */}
            </StyledLogoHeader>
          </Text>
        </Col>
      </Row>
    </StyledHeader>
  );
};

export default _appHeader;